import React from "react";
import { useAuth } from "@/context/AuthContext";
import { useList } from "@/lib/hooks";
import { PageHeader, Panel, EmptyState } from "@/components/common";
import { Pulse, Users, Truck, ClipboardText, Megaphone, CurrencyDollar, Receipt, Prohibit, UsersThree, ChatsCircle } from "@phosphor-icons/react";

const ICONS = {
  created_lead: Users, updated_lead_status: Users, created_load: Truck, updated_load_status: Truck,
  created_task: ClipboardText, completed_task: ClipboardText, posted_announcement: Megaphone,
  logged_finance: CurrencyDollar, created_invoice: Receipt, added_dnu_broker: Prohibit,
  created_user: UsersThree, created_group: ChatsCircle,
};
const LABELS = {
  created_lead: "Created lead", updated_lead_status: "Updated lead", created_load: "Created load",
  updated_load_status: "Updated load", created_task: "Created task", completed_task: "Completed task",
  posted_announcement: "Posted announcement", logged_finance: "Logged finance entry",
  created_invoice: "Created invoice", added_dnu_broker: "Added DNU broker", created_user: "Added team member",
  created_group: "Created group",
};

export default function Activity() {
  const { user } = useAuth();
  const { data: acts = [], isLoading } = useList("activities", "/activities", { refetchInterval: 15000 });

  return (
    <div>
      <PageHeader title="My Activity" subtitle={user.role === "admin" ? "Team activity feed across the operation" : "Your recent work and actions"} />
      <Panel>
        {isLoading ? <div className="p-6 text-slate-500">Loading…</div> : acts.length === 0 ? (
          <EmptyState icon={Pulse} title="No activity yet" hint="Your actions will be tracked here." />
        ) : (
          <div className="divide-y divide-slate-100">
            {acts.map((a) => {
              const Icon = ICONS[a.action] || Pulse;
              return (
                <div key={a.id} className="px-5 py-3 flex items-center gap-3 hover:bg-slate-50 transition-colors" data-testid={`activity-${a.id}`}>
                  <div className="p-2 rounded-md bg-slate-50 border border-slate-200 text-blue-600 shrink-0"><Icon size={16} weight="duotone" /></div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm text-slate-700"><span className="font-medium">{LABELS[a.action] || a.action}</span>{a.detail ? <span className="text-slate-500"> · {a.detail}</span> : ""}</p>
                    {user.role === "admin" && <p className="text-xs text-slate-500">{a.user_name} ({a.role})</p>}
                  </div>
                  <span className="text-xs text-slate-400 shrink-0">{new Date(a.created_at).toLocaleString()}</span>
                </div>
              );
            })}
          </div>
        )}
      </Panel>
    </div>
  );
}
